module.exports = __webpack_public_path__ + "media/gastric ca.acebfda8.wav";